import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {usePathname} from 'next/navigation';
import {useMemo} from 'react';

import {AppType} from '@web-catalog/types';

import {useHeaderAppTypeValue} from '@web-catalog/store';

const findLinkIndex = (
  links: HeaderProps['links'],
  urlRegex: RegExp,
  title: string,
) => {
  const index = links.findIndex(
    (item) => urlRegex.test(item.href) || item.title === title,
  );
  return index === -1 ? undefined : index + 1;
};

export const useActiveLinkOrder = (links: HeaderProps['links']) => {
  const pathName = usePathname();
  const currentAppType = useHeaderAppTypeValue();

  return useMemo(() => {
    const appsIndex = findLinkIndex(links, /\/catalog$/, 'Приложения');
    const gamesIndex = findLinkIndex(links, /\/catalog\/games$/, 'Игры');

    const appTypeToLinkOrder = {
      [AppType.GAMES]: gamesIndex,
      [AppType.MAIN]: appsIndex,
    };

    if (!pathName) {
      return appsIndex;
    }
    if (pathName.startsWith('/games')) {
      return gamesIndex || appsIndex;
    }
    if (pathName.startsWith('/kiosk')) {
      return findLinkIndex(links, /\/catalog\/kiosk$/, 'Киоск') || appsIndex;
    }
    if (pathName.startsWith('/app/') || pathName.startsWith('/event/')) {
      return currentAppType
        ? appTypeToLinkOrder[currentAppType] || appsIndex
        : undefined;
    }
    return appsIndex;
  }, [pathName, currentAppType]);
};
